/* Programming contest management system
 * Copyright © 2012 Luca Wehrstedt <luca.wehrstedt@gmail.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import $ from "jquery";
import DataStore from "./DataStore.js";
import HistoryStore from "./HistoryStore.js";
import UserDetail from "./UserDetail.js";
import TimeView from "./TimeView.js";
import TeamSearch from "./TeamSearch.js";
import Overview from "./Overview.js";
import Scoreboard from "./Scoreboard.js";
import Timeline from "./Timeline.js";
import Follow from "./Follow.js";
import Settings from "./Settings.js";
import Debug from "./Debug.js";

if (!window.console) {
    window.console = new Object();
}

if (!window.console.log) {
    window.console.log = function () {};
}

if (!window.console.info) {
    window.console.info = function () {};
}

if (!window.console.warn) {
    window.console.warn = function () {};
}

if (!window.console.error) {
    window.console.error = function () {};
}

$(document).ready(function() {
    // Expose the scrollbar's width so non-scrolling elements (the timeline)
    // can reserve the same gutter and stay aligned with the scoreboard
    var frame = document.getElementById("InnerFrame");
    if (frame) {
        document.documentElement.style.setProperty(
            "--scrollbar-width", (frame.offsetWidth - frame.clientWidth) + "px");
    }

    Settings.init();
    Debug.init();

    // The data is imported lazily (see the module script in index.html), so
    // the page shell above renders right away and hydrates when it arrives
    window.data_promise.then(function () {
        DataStore.init(function() {
            HistoryStore.init();
            UserDetail.init();
            TimeView.init();
            TeamSearch.init(function() {
              DataStore.init_selections();
            });
            Overview.init();
            Scoreboard.init();
            Timeline.init();
            Follow.init();
        });
    }, function () {
        $("#LoadError").show();
    });
});
